/**
 * User-facing copy aligned with dashboard-desktop-app/pep-login/loginToPep.html.
 */
export const PEP_LOGIN_TITLE = 'Login to Hilton PEP'

export const PEP_LOGIN_SUBTITLE = 'Sign in to your Hilton PEP account'

export const PEP_LOGIN_LABEL_USERNAME = 'Username'

export const PEP_LOGIN_LABEL_PASSWORD = 'Password'

export const PEP_LOGIN_LABEL_LOGIN_URL = 'Login URL'

export const PEP_LOGIN_PLACEHOLDER_USERNAME = 'Enter your username'

export const PEP_LOGIN_PLACEHOLDER_PASSWORD = 'Enter your password'

export const PEP_LOGIN_PLACEHOLDER_LOGIN_URL = 'Enter PEP login URL'

export const PEP_LOGIN_BUTTON_SIGN_IN = 'Sign In'

export const PEP_LOGIN_BUTTON_CANCEL = 'Cancel'

export const PEP_LOGIN_LOADING_TEXT = 'Signing in...'

export const PEP_LOGIN_FOOTER = 'Secure login powered by Directful Dashboard'

export const PEP_LOGIN_URL_TOOLTIP_LINES = [
  'https://login.pep.hilton.com/hk-home/index.html#/',
  'https://enterprise.pep-pv.hilton.com/hk-home/index.html#/'
]

export const PEP_LOGIN_DEFAULT_URL =
  'https://login.pep.hilton.com/hk-home/index.html#/'

/**
 * @param {string} [step]
 * @returns {string}
 */
export function formatPepLoginError(step) {
  return `Something went wrong on ${step || 'unknown step'}`
}
